module.exports = __webpack_public_path__ + "static/media/la.d4742a0b.svg";